import { TransactionHistoryRequestModel } from "api/baseTransactionHistory/TransactionHistoryRequestModel";
import { TypeOfTravelSimEnum } from "utils/enums/TypeOfTravelSimEnum";

export class TravelSimRegistrationRequestModel extends TransactionHistoryRequestModel {
  carrier?: Array<string>;
  code?: string;
  created?: Record<string, unknown>[];
  fromDate?: string;
  limit?: number;
  page?: number;
  pagination?: boolean;
  isdnOrIccid?: string;
  status?: number;
  toDate?: string;
  package?: Array<string>;
  type?: number;
  simType?: number;
  nation?: string;
  typeofSim?: TypeOfTravelSimEnum;
  store?: string;
  staff?: string;
  order?: string;
  isOnlyStore?: string;
  transRef?: string;

  constructor(data?: {
    carrier?: Array<string>;
    code?: string;
    created?: Record<string, unknown>[];
    fromDate?: string;
    limit?: number;
    page?: number;
    pagination?: boolean;
    status?: number;
    simType?: number;
    toDate?: string;
    package?: Array<string>;
    nation?: string;
    typeofSim?: TypeOfTravelSimEnum;
    type?: number;
    store?: string;
    staff?: string;
    order?: string;
    isOnlyStore?: string;
    isdnOrIccid?: string;
    transRef?: string;
  }) {
    super();
    this.status = data?.status;
    this.code = data?.code;
    this.carrier = data?.carrier;
    this.isdnOrIccid = data?.isdnOrIccid;
    this.page = data?.page;
    this.limit = data?.limit;
    this.pagination = data?.pagination;
    this.fromDate = data?.fromDate;
    this.simType = data?.simType;
    this.toDate = data?.toDate;
    this.package = data?.package;
    this.created = data?.created;
    this.nation = data?.nation;
    this.type = data?.type;
    this.typeofSim = data?.typeofSim;
    this.store = data?.store;
    this.staff = data?.staff;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
    this.transRef = data?.transRef;
  }
}
